import { Feature, FeatureWithRouterFactory } from '@common-stack/client-react';
import { interfaces } from 'inversify';
import LayoutModule from '@workbench-stack/layout';
import ModalModule from '@workbench-stack/modal';
import { ThemeModule } from '@workbench-stack/components';
import SettingsModule from '@workbench-stack/settings';
import OutputModule from '@workbench-stack/output-browser';
import { resolvers, schema, defaults, fragmentMatcher, dataIdFromObject } from './graphql';
import { workbenchModule } from './containers';
import { ClientTypes as BrowserTypes } from '@common-stack/client-core';
import {
  IEditorService,
  ClientTypes,
  IModelService,
  IClientService,
  IModeService,
  IContextKeyService,
  ICodeEditorService,
  IResourceContextKey,
  IEditorGroupsService,
  ILifecycleService,
  IJSONEditingService,
  IClientWorkspaceContextService as IWorkspaceContextService,
  IApolloService,
  IClientConfigurationService,
  INotificationsService,
  IDialogService,
  IStatusbarService,
  IKeybindingService,
  IKeymapService,
  IStorageService,
  ICommandService,
  IKeybindingEditingService,
  IContextMenuService,
  IQuickInputService,
} from '@workbench-stack/core';
import { ApolloClient } from 'apollo-client';


const workbenchServiceGen = (container: interfaces.Container): Pick<IClientService, Exclude<keyof IClientService, 'textFileService' | 'untitledEditorService' | 'preferenceEditorService'>> => {
  return {
    editorService: container.get<IEditorService>(ClientTypes.IEditorService),
    editorGroupsService: container.get<IEditorGroupsService>(ClientTypes.IEditorGroupsService),
    codeEditorService: container.get<ICodeEditorService>(ClientTypes.ICodeEditorService),
    modelService: container.get<IModelService>(ClientTypes.IModelService),
    modeService: container.get<IModeService>(ClientTypes.IModeService),
    contextKeyService: container.get<IContextKeyService>(ClientTypes.IContextKeyService),
    resourceContextKey: container.get<IResourceContextKey>(ClientTypes.IResourceContextKey),
    lifecycleService: container.get<ILifecycleService>(ClientTypes.ILifecycleService),
    jsonEditingService: container.get<IJSONEditingService>(ClientTypes.IJSONEditingService),
    workspaceContextService: container.get<IWorkspaceContextService>(ClientTypes.IWorkspaceContextService),
    configurationService: container.get<IClientConfigurationService>(ClientTypes.IConfigurationService),
    notificationService: container.get<INotificationsService>(ClientTypes.INotificationService),
    dialogService: container.get<IDialogService>(ClientTypes.IDialogService),
    statusbarService: container.get<IStatusbarService>(ClientTypes.IStatusbarService),
    keybindingService: container.get<IKeybindingService>(ClientTypes.IKeybindingService),
    keybindingEditingService: container.get<IKeybindingEditingService>(ClientTypes.IKeybindingEditingService),
    keymapService: container.get<IKeymapService>(ClientTypes.IKeymapService),
    storageService: container.get<IStorageService>(ClientTypes.IStorageService),
    commandService: container.get<ICommandService>(ClientTypes.ICommandService),
    contextMenuService: container.get<IContextMenuService>(ClientTypes.IContextMenuService),
    quickInputService: container.get<IQuickInputService>(ClientTypes.IQuickInputService),
  };
};

const apolloServiceServiceGen = (container: interfaces.Container): IApolloService => {
  return {
    apolloClient: container.get<ApolloClient<any>>(BrowserTypes.ApolloClient),
    cache: container.get<any>(BrowserTypes.InMemoryCache),
    utility: container.get(BrowserTypes.UtilityClass),
  };
};
export default new Feature(
  FeatureWithRouterFactory,
  LayoutModule, ThemeModule,
  ModalModule,
  SettingsModule,
  OutputModule,
  new Feature({
    clientStateParams: [{
      resolvers, typeDefs: [schema], defaults, fragmentMatcher: <any>fragmentMatcher,
    }],
    createContainerFunc: workbenchModule,
    createServiceFunc: [workbenchServiceGen, apolloServiceServiceGen],
    dataIdFromObject,
  }),
);
